(() => {
    document.addEventListener('DOMContentLoaded', () => {
        const items = [{
            "title": "Justification",
            "href": "./files/Justification.pdf"
        },
        {
            "title": "Election",
            "href": "./files/Election.pdf"
        },
        {
            "title": "The Path",
            "href": "./files/Path.pdf"
        },
        {
            "title": "Hebrews",
            "href": "./files/Hebrews.pdf"
        },
        {
            "title": "The Promise",
            "href": "./files/The%20Promise.pdf"
        },
        {
            "title": "The Trinity",
            "href": "./files/The%20Trinity.pdf"
        },
        {
            "title": "His Return",
            "href": "./files/Return.pdf"
        },
        {
            "title": "Faith",
            "href": "./files/Faith.pdf"
        },
        {
            "title": "Romans",
            "href": "./files/Romans.pdf"
        },
        {
            "title": "Ephesians",
            "href": "./files/Ephesians.pdf"
        },
        {
            "title": "Cosmology",
            "href": "./files/Cosmology.pdf"
        },
        {
            "title": "Paul's Hope",
            "href": "./files/Paul's_Hope.pdf"
        },
        {
            "title": "Reformed Religion",
            "href": "./files/Reformed_Religion.pdf"
        },
        {
            "title": "Hebrews Who",
            "href": "./files/Hebrews_Who.pdf"
        },
        {
            "title": "Words",
            "href": "./files/Words.pdf"
        },
    ];

        const container = document.getElementById('card-items-container')
        items.forEach(item => {
            const cardItem = document.querySelector('.card-container').cloneNode(true);

            cardItem.querySelector('.card-title').innerHTML = item.title;
            cardItem.querySelector('.card-download').href = item.href;

            container.append(cardItem);
        })
    })
})();
